import React, { useContext } from 'react';

export const SweepContext = React.createContext({
    sweep: {
        sweepId: null,
        name: '-',
        prize: '-',
        date: null,
        event: {}
    },
    setSweep: () => {}
});

export const useSweep = () => useContext(SweepContext);
